import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import BetaNavbar from "./components/BetaNavbar";

const V2NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackToHome = () => {
    const savedWorkspaceId = localStorage.getItem("selectedWorkspace");
    if (savedWorkspaceId) {
      navigate(`/v2/${savedWorkspaceId}`);
    } else {
      navigate("/v2");
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <BetaNavbar hideWorkspaceSelector />
      <div className="flex min-h-[calc(100vh-72px)] items-center justify-center px-4">
        <div className="w-full max-w-[400px] rounded-[20px] bg-white p-8 shadow-[0_4px_24px_rgba(0,0,0,0.08)]">
          {/* Icon */}
          <div className="mb-6 flex justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#FEF3E7]">
              <AlertCircle size={32} className="text-[#E07A3A]" />
            </div>
          </div>

          {/* Content */}
          <div className="mb-8 text-center">
            <h1 className="mb-2 text-[48px] font-bold text-[#111827]">404</h1>
            <h2 className="mb-2 text-xl font-semibold text-[#111827]">
              {t("navigation.notFound.title")}
            </h2>
            <p className="text-sm text-[#6B7280]">
              {t("navigation.notFound.description")}
            </p>
          </div>

          {/* Back to home button */}
          <button
            onClick={handleBackToHome}
            className="flex w-full items-center justify-center gap-2 rounded-[10px] px-5 py-3 text-sm font-semibold text-white transition duration-150 hover:opacity-90"
            style={{
              background: "linear-gradient(135deg, #E8854A 0%, #D66B2E 100%)",
            }}
          >
            <ArrowLeft size={16} />
            {t("navigation.notFound.backToHome")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default V2NotFound;
